__turbopack_context__.v({
  "active": "GnVc2q_active",
  "content": "GnVc2q_content",
  "segment": "GnVc2q_segment" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "typography": "GnVc2q_typography",
});
